import {
  IGetUserApprovalForPurchaseParams,
  TGetUserApproval,
  TGetUserApprovalDetail,
} from 'interfaces/Approve/Approve';
import {
  GET_APPROVAL_STATUS,
  GET_APPROVAL_TYPES,
  GET_CUSTOMER_APPROVAL,
  GET_ORDER_APPROVAL,
  GET_PURCHASE_APPROVAL,
  GET_USER_APPROVAL,
  GET_USER_APPROVAL_FOR_ORDER,
  GET_USER_APPROVAL_FOR_PURCHASE,
  GET_USER_CUSTOMER_APPROVAL,
  UPDATE_APPROVAL_STATUS,
} from './GraphQL/Queries/approveQuery';
import {
  APPROVE_VARIABLE,
  IUpdateApprovalStatus,
} from './GraphQL/Variables/approve';
import axiosGraphQL from './GraphQL/axiosGraphQL';

export const ApproveApi = {
  getUserApproval: async (params: TGetUserApproval) => {
    return await axiosGraphQL.post('/graphql', {
      query: GET_USER_APPROVAL,
      variables: APPROVE_VARIABLE.getUserApproval(params),
    });
  },
  // getUserApprovalById: async (id: string) => {
  getUserApprovalById: async (params: TGetUserApprovalDetail) => {
    return await axiosGraphQL.post('/graphql', {
      query: GET_USER_APPROVAL,
      variables: APPROVE_VARIABLE.getUserApprovalById(params),
    });
  },
  getApprovalTypes: async () => {
    return await axiosGraphQL.post('/graphql', {
      query: GET_APPROVAL_TYPES,
    });
  },
  getApprovalStatus: async () => {
    return await axiosGraphQL.post('/graphql', {
      query: GET_APPROVAL_STATUS,
      variables: APPROVE_VARIABLE.getApprovalStatus(),
    });
  },
  getUserApprovalForPurchase: async (
    params: IGetUserApprovalForPurchaseParams,
  ) => {
    return await axiosGraphQL.post('/graphql', {
      query: GET_USER_APPROVAL_FOR_PURCHASE,
      variables: APPROVE_VARIABLE.getUserApprovalForPurchase(params),
    });
  },
  getPurchaseApproval: async (purchaseId: string) => {
    return await axiosGraphQL.post('/graphql', {
      query: GET_PURCHASE_APPROVAL,
      variables: APPROVE_VARIABLE.getPurchaseApproval(purchaseId),
    });
  },
  getUserApprovalForOrder: async (id: string) => {
    return await axiosGraphQL.post('/graphql', {
      query: GET_USER_APPROVAL_FOR_ORDER,
      variables: APPROVE_VARIABLE.getUserApprovalForOrder(id),
    });
  },
  getOrderApproval: async (orderId: string) => {
    return await axiosGraphQL.post('/graphql', {
      query: GET_ORDER_APPROVAL,
      variables: APPROVE_VARIABLE.getOrderApproval(orderId),
    });
  },
  getUserCustomerApproval: async (id: string) => {
    return await axiosGraphQL.post('/graphql', {
      query: GET_USER_CUSTOMER_APPROVAL,
      variables: APPROVE_VARIABLE.getUserCustomerApproval(id),
    });
  },
  getCustomerApproval: async (customerId: string) => {
    return await axiosGraphQL.post('/graphql', {
      query: GET_CUSTOMER_APPROVAL,
      variables: APPROVE_VARIABLE.getCustomerApproval(customerId),
    });
  },
  updateApprovalStatus: async (params: IUpdateApprovalStatus) => {
    return await axiosGraphQL.post('/graphql', {
      query: UPDATE_APPROVAL_STATUS,
      variables: APPROVE_VARIABLE.updateApprovalStatus(params),
    });
  },
};
